import { BaseButtonItem } from 'components/buttonGroup/model';
import { BaseTapItem } from 'components/tabList/model';

export const rankingAssetType: BaseButtonItem[] = [
  { type: 'persona', label: 'chat.rewards_monthly_sales_characters_button' },
  { type: 'universe', label: 'chat.rewards_monthly_sales_universes_button' },
  { type: 'scene', label: 'chat.rewards_monthly_sales_scenes_button' },
];
export const rankingAssetOwner: BaseTapItem[] = [
  {
    type: 'my',
    label: 'chat.rewards_monthly_sales_my_assets',
  },
  {
    type: 'entire',
    label: 'chat.rewards_monthly_sales_total',
  },
];
